import { ConnectButton } from "@/components/connect-button";
import {
  TransactionDialog,
  transactionInner,
} from "@/components/transaction/transaction-dialog";
import { decodeTransactions, getBenchInstanceClient } from "@/lib/clients";
import { N, shorten } from "@/lib/utils";
import { BenchStateFull } from "@myth-finance/bench-sdk";
import { useWallet } from "@txnlab/use-wallet";
import { Wallet, UserRound, ChevronRight } from "lucide-react";

export function EndBenchButton({
  data,
  reloadState,
}: {
  data: BenchStateFull;
  reloadState: () => any;
}) {
  const { activeAddress } = useWallet();

  const makeEndTransactions = async () => {
    return decodeTransactions(
      await getBenchInstanceClient(data.appId, data.registryAppId).makeEndTxns({
        sender: activeAddress!,
      })
    );
  };

  return (
    <TransactionDialog
      type="purchase"
      trigger={(onClick) => (
        <ConnectButton onClick={onClick}>
          <Wallet size={18} className="mr-1.5" />
          <span>End bench</span>
        </ConnectButton>
      )}
      transactionBuilder={() => makeEndTransactions()}
      title={`Ending ${data.sellingUnitName} bench sale`}
      onClose={() => reloadState()}
      onSuccess={() => reloadState()}
    >
      {transactionInner(
        "operation",
        <div className="flex-col flex gap-2">
          <div>
            You are going to <strong>end this bench sale.</strong>
          </div>
          <div className="text-destructive">
            Note: once ended, this bench sale can not be resumed.
          </div>
        </div>,
        <>
          <div className="flex justify-between gap-2 mb-2">
            <div className="flex items-center">
              <UserRound size={18} className="mr-1" /> Account
            </div>{" "}
            <span>{shorten(activeAddress!)}</span>
          </div>
          <div className="flex justify-between gap-2 text-foreground">
            <div className="flex items-center">
              <ChevronRight size={18} className="mr-1" /> Call app: end
            </div>
            <span>{N(data.appId)}</span>
          </div>
        </>
      )}
    </TransactionDialog>
  );
}
